const { handleError, handleResponse, api } = require("./baseApi");
const api_config = require("./api_config");
var qs = require('qs');

const BASE_URL = "reduce/v1";

function getFactsForUser(email) {
    return api
        .get(`${BASE_URL}/facts`, {
            headers: {
                "x-api-key": `${api_config.carbon_app_api_key}`
            },
            params: {email}
        })
        .then(handleResponse)
        .catch(handleError);
}

function getActionsForUser(email) {
    return api
        .get(`${BASE_URL}/user-actions`, {
            headers: {
                "x-api-key": `${api_config.carbon_app_api_key}`
            },
            params: {email}
        })
        .then(handleResponse)
        .catch(handleError);
}

function createActionUserEngagement(data) {
    return api
        .post(`${BASE_URL}/user-actions/engagements`,JSON.stringify(data), {
            headers: {
                "x-api-key": `${api_config.carbon_app_api_key}`
            }
        })
        .then(handleResponse)
        .catch(handleError);
}

function getGroupReduceSummary(groupId, locale) {
    return api
        .get(
            `${BASE_URL}/groups/${groupId}/summary`,
            {
                headers: {
                    "x-api-key": `${api_config.carbon_app_api_key}`
                },
                params: {locale}
            }
        )
        .then(handleResponse)
        .catch(handleError);
}

module.exports = {
    getFactsForUser,
    getActionsForUser,
    createActionUserEngagement,
    getGroupReduceSummary
};
